import { useEffect, useState } from 'react';
import API from 'utils/atolyeAPI';

const ProductCustomAttributes = ({ product }) => {
  const id = product?.id;

  const AtolyeAPI = new API();

  const [customAttributes, setCustomAttributes] = useState([]);

  useEffect(() => {
    if (id) {
      getProductCustomAttributes(id);
    }
  }, [id]);

  const getProductCustomAttributes = async (id) => {
    // API call to fetch custom attributes
    try {
      const response = await AtolyeAPI.get(`/products/${id}/custom-attributes`);
      const { results } = response;
      setCustomAttributes(results.filter((attr) => attr.required));
      console.log(results);
    } catch (error) {
      console.error('Error fetching custom attributes:', error);
    }
  };

  return customAttributes.length > 0 ? (
    <div>
      <h5>Özel Alanlar (yeni)</h5>
      <div className="d-flex">
        {customAttributes.map((attr) => (
          <div key={attr.id} className="p-2 border-bottom">
            <strong>{attr.name}:</strong>
            <input className="form-control" type="text" value={attr.value} disabled />
          </div>
        ))}
      </div>
    </div>
  ) : null;
};

export default ProductCustomAttributes;
